import React from "react";

export function EditDeviceCheckbox({ label, value, onChange, disabled }) {

    return (
        <div className="form-group edit-device-option-row">
            <label className={`edit-device-option-label ${disabled ? "is-disabled" : ""}`}>
                    <input type="checkbox"
                        className="edit-device-option-input"
                        checked={!!value}
                        disabled={disabled}
                        onChange={disabled ? null : () => onChange(!value)} />
                    <span className={`edit-device-option-box ${value ? "is-checked" : ""}`} aria-hidden="true">
                        <span className="edit-device-option-check">✓</span>
                    </span>
                    <span className="edit-device-option-text">{label}</span>
                </label>
        </div>)
}

export default EditDeviceCheckbox;
